<template>
    <div class="offer_modal-mask">
        <div class="offer_modal-wrapper">
            <div class="offer_modal-container ZAfont_family">
                <div class="offer_modal-header">
                    <div class="offer_modal-content-a4">
                        <h3 class="my_color_00338e" style="font-weight:600">
                            <div>
                                <img style="float: right" class="ZAbrand" src="../../../../public/img/ZAbrands/ZAoriginal.svg" />
                                <div>Preisindikation</div>
                                <div>
                                    <span>Bestellanfrage</span>
                                    <span style="padding: 2px 4px;">{{zlw}}</span>
                                </div>
                            </div>
                        </h3>
                    </div>
                </div>
                <div class="offer_modal-body">
                    <div class="offer_modal-content-a4" style="margin-top:10px">
                        <div class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 180px 1fr; row-gap: 2px; column-gap: 20px;">
                            <span v-if="zlw!=null&&zlw!=''">Auslegung:</span>
                            <span v-if="zlw!=null&&zlw!=''">{{zlw}}</span>
                            <span>Projekt:</span>
                            <span>{{project}}</span>
                            <span v-if="customerName!=null&&customerName!=''">Kunde:</span>
                            <span v-if="customerName!=null&&customerName!=''">{{customerName}}</span>
                            <span v-if="customerNumber!=null&&customerNumber!=''">Kundennummer:</span>
                            <span v-if="customerNumber!=null&&customerNumber!=''">{{customerNumber}}</span>
                            <span v-if="accountName!=null&&accountName!=''">Kontakt:</span>
                            <span v-if="accountName!=null&&accountName!=''">{{accountName}}</span>
                            <span v-if="email!=null&&email!=''">Email:</span>
                            <span v-if="email!=null&&email!=''">{{email}}</span>
                            <span>Datum:</span>
                            <span>{{date}}</span>
                            <span>gültig bis:</span>
                            <span>{{validityDate}}</span>
                            <span v-if="editor!=null&&editor!=''">Bearbeiter/in:</span>
                            <span v-if="editor!=null&&editor!=''">{{editor}}</span>
                        </div>
                    </div>
                    <div class="offer_modal-content-a4">
                        <table v-if="sumMotor_Show==true">
                            <tr class="section-title">
                                <th class="left headline_size" style="font-weight:600; width:50%">Antrieb</th>
                                <th class="right">Brutto [€]</th>
                                <th class="right">Rabatt [%]</th>
                                <th class="right">Netto [€]</th>
                            </tr>
                            <tr class="compact-motor-row">
                                <td class="my_color_00338e headline_size" style="font-weight: 600">Motor</td>
                                <td class="right paddingColumn"></td>
                                <td class="right paddingColumn"></td>
                                <td class="right paddingColumn"></td>
                            </tr>
                            <tr v-if="mo_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Typ:</span>
                                        <span v-if="mo_Txt!=null&&mo_Txt!=''">{{mo_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(mo_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(mo_Disc)}}</td>
                                <td v-if="mo_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(mo_NP)}}</td>
                                <td v-if="mo_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="mo_Show==true&&u_Show==true" class="ZAfont_size compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Spannung:</span>
                                        <span v-if="u_Txt!=null&&u_Txt!=''">{{u_Txt}} mm</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(u_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(u_Disc)}}</td>
                                <td v-if="u_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(u_NP)}}</td>
                                <td v-if="u_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="mo_Show==true" class="ZAfont_size compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Maximale Achslast:</span>
                                        <span v-if="alast_Txt!=null&&alast_Txt!=''">{{alast_Txt}} kg</span>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="mo_Show==true" class="ZAfont_size compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Nenndrehzahl:</span>
                                        <span v-if="nr_Txt!=null&&nr_Txt!=''">{{nr_Txt}} rpm</span>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="mo_Show==true" class="ZAfont_size compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Nennstrom:</span>
                                        <span v-if="ni_Txt!=null&&ni_Txt!=''">{{ni_Txt}} A</span>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="mo_Show==true" class="ZAfont_size compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Nenndrehmoment:</span>
                                        <span v-if="nm_Txt!=null&&nm_Txt!=''">{{nm_Txt}} Nm</span>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="mo_Show==true&&mip_Show==true" class="ZAfont_size compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Schutzklasse:</span>
                                        <span>{{mip_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(mip_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(mip_Disc)}}</td>
                                <td v-if="mip_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(mip_NP)}}</td>
                                <td v-if="mip_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="mo_Show==true&&housV_Show==true" class="ZAfont_size compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Gehäuseausf. A (SM700):</span>
                                        <span>{{housV_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(housV_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(housV_Disc)}}</td>
                                <td v-if="housV_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(housV_NP)}}</td>
                                <td v-if="housV_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="mo_Show==true&&motorCblCon_Show==true" class="ZAfont_size compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Angeschlossene Motorleitung:</span>
                                        <span>{{motorCblCon_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(motorCblCon_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(motorCblCon_Disc)}}</td>
                                <td v-if="motorCblCon_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(motorCblCon_NP)}}</td>
                                <td v-if="motorCblCon_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="mo_Show==true&&motorCbl_Show==true" class="ZAfont_size compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Angeschlossene Motorleitung:</span>
                                        <span>{{motorCbl_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(motorCbl_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(motorCbl_Disc)}}</td>
                                <td v-if="motorCbl_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(motorCbl_NP)}}</td>
                                <td v-if="motorCbl_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="mo_Show==true&&motDis_Show==true" class="ZAfont_size compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Antrieb zerlegt:</span>
                                        <span>{{motDis_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(motDis_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(motDis_Disc)}}</td>
                                <td v-if="motDis_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(motDis_NP)}}</td>
                                <td v-if="motDis_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="tm_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Temperaturüberw.:</span>
                                        <span>{{tm_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(tm_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(tm_Disc)}}</td>
                                <td v-if="tm_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(tm_NP)}}</td>
                                <td v-if="tm_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="fan_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Fremdbelüftung:</span>
                                        <span v-if="fan_Txt!=null&&fan_Txt==true">{{$t('1035')}}</span>
                                        <span v-if="fan_Txt==null||fan_Txt==false">{{$t('1036')}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(fan_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(fan_Disc)}}</td>
                                <td v-if="fan_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(fan_NP)}}</td>
                                <td v-if="fan_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="td_Show==true" class="abstand-zeile"></tr>
                            <tr v-if="td_Show==true" class="compact-motor-row">
                                <td class="my_color_00338e headline_size" style="font-weight: 600; font-size: 18px">Treibscheibe</td>
                                <td class="right paddingColumn ZAfont_size"></td>
                                <td class="right paddingColumn ZAfont_size"></td>
                                <td class="right paddingColumn ZAfont_size"></td>
                            </tr>
                            <tr v-if="td_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Durchmesser:</span>
                                        <span>{{td_Txt}} mm</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(td_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(td_Disc)}}</td>
                                <td v-if="td_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(td_NP)}}</td>
                                <td v-if="td_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="ra_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Rillenabstand:</span>
                                        <span>{{ra_Txt}} mm</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(ra_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(ra_Disc)}}</td>
                                <td v-if="ra_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(ra_NP)}}</td>
                                <td v-if="ra_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Kranzbreite:</span>
                                        <span>{{tbTxt}} mm</span>
                                    </div>
                                </td>
                            </tr>
                            <tr class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Seildurchmesser:</span>
                                        <span>{{sd_Txt}} mm</span>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="ugr_Txt!=null&&ugr_Txt!=''" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Sitzrille:</span>
                                        <span>{{ugr_Txt}} °</span>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="vgr_Txt!=null&&vgr_Txt!=''" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Keilrille:</span>
                                        <span>{{vgr_Txt}} °</span>
                                    </div>
                                </td>
                            </tr>
                            <tr class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Gehaertet:</span>
                                        <span v-if="th_Txt!=null&&th_Txt==true">{{$t('1035')}}</span>
                                        <span v-if="th_Txt==null||th_Txt==false">{{$t('1036')}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(th_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(th_Disc)}}</td>
                                <td v-if="th_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(th_NP)}}</td>
                                <td v-if="th_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>{{$t('3538')}}:</span>
                                        <span v-if="sas_Txt!=null&&sas_Txt==true">{{$t('1035')}}</span>
                                        <span v-if="sas_Txt==null||sas_Txt==false">{{$t('1036')}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(sas_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(sas_Disc)}}</td>
                                <td v-if="sas_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(sas_NP)}}</td>
                                <td v-if="sas_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="tklem_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Treibscheibenklemme:</span>
                                        <span>{{tklem_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(tklem_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(tklem_Disc)}}</td>
                                <td v-if="tklem_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(tklem_NP)}}</td>
                                <td v-if="tklem_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="tsabd_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Treibscheibenabdeckung:</span>
                                        <span v-if="tsabd_Txt!=null&&tsabd_Txt==true">{{$t('1035')}}</span>
                                        <span v-if="tsabd_Txt==null||tsabd_Txt==false">{{$t('1036')}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(tsabd_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(tsabd_Disc)}}</td>
                                <td v-if="tsabd_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(tsabd_NP)}}</td>
                                <td v-if="tsabd_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="tsabD1_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Treibscheibenabdeckung:</span>
                                        <span>{{tsabD1_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(tsabD1_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(tsabD1_Disc)}}</td>
                                <td v-if="tsabD1_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(tsabD1_NP)}}</td>
                                <td v-if="tsabD1_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="bhl_Show==true||ksich_Show==true" class="abstand-zeile"></tr>
                            <tr v-if="bhl_Show==true||ksich_Show==true" class="compact-motor-row">
                                <td class="my_color_00338e headline_size" style="font-weight: 600; font-size: 18px">Bremse</td>
                                <td class="right paddingColumn ZAfont_size"></td>
                                <td class="right paddingColumn ZAfont_size"></td>
                                <td class="right paddingColumn ZAfont_size"></td>
                            </tr>
                            <tr v-if="bhl_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Mechanisches Lüften:</span>
                                        <span v-if="(bhl_Txt =='without')">{{$t('1425')}}</span>
                                        <span v-if="(bhl_Txt =='hand release')">{{$t('1426')}}</span>
                                        <span v-if="(bhl_Txt =='bowden cable hand release')">{{$t('1427')}}</span>
                                        <span v-if="(bhl_Txt =='without bowden cable hand release')">{{$t('1428')}}</span>
                                        <span v-if="(bhl_Txt =='prepare for bowden cable hand release')">{{$t('1453')}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(bhl_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(bhl_Disc)}}</td>
                                <td v-if="bhl_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(bhl_NP)}}</td>
                                <td v-if="bhl_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="bowden_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Bowdenzug:</span>
                                        <span>{{bowden_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(bowden_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(bowden_Disc)}}</td>
                                <td v-if="bowden_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(bowden_NP)}}</td>
                                <td v-if="bowden_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="ksich_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Lüftüberwachung:</span>
                                        <span v-if="(ksich_Txt =='microswitch')">{{$t('1429')}}</span>
                                        <span v-if="(ksich_Txt =='proximity switch')">{{$t('1430')}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(ksich_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(ksich_Disc)}}</td>
                                <td v-if="ksich_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(ksich_NP)}}</td>
                                <td v-if="ksich_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="enc_Show==true" class="abstand-zeile"></tr>
                            <tr v-if="enc_Show==true" class="compact-motor-row">
                                <td class="my_color_00338e headline_size" style="font-weight: 600; font-size: 18px">Geber</td>
                                <td class="right paddingColumn ZAfont_size"></td>
                                <td class="right paddingColumn ZAfont_size"></td>
                                <td class="right paddingColumn ZAfont_size"></td>
                            </tr>
                            <tr v-if="enc_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Typ:</span>
                                        <span>{{enc_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(enc_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(enc_Disc)}}</td>
                                <td v-if="enc_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(enc_NP)}}</td>
                                <td v-if="enc_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr class="abstand-zeile"></tr>
                            <tr class="sum">
                                <td class="headline_size" style="width:50%">Antrieb</td>
                                <td class="right paddingColumn ZAfont_size"> </td>
                                <td class="right paddingColumn ZAfont_size"> </td>
                                <td v-if="sumMotor_OnD==false" class="right paddingColumn headline_size">{{isDataANumber(sumMotor)}}</td>
                                <td v-if="sumMotor_OnD==true" class="right paddingColumn headline_size">{{$t('3378')}}</td>
                            </tr>
                        </table>
                        <table v-if="sumFrame_Show==true">
                            <tr class="section-title">
                                <th class="left headline_size" style="font-weight:600; font-size:20px; width:50%">Maschinenrahmen</th>
                                <th class="right">Brutto [€]</th>
                                <th class="right">Rabatt [%]</th>
                                <th class="right">Netto [€]</th>
                            </tr>
                            <tr v-if="frame_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Typ:</span>
                                        <span>{{frame_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(frame_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(frame_Disc)}}</td>
                                <td v-if="frame_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(frame_NP)}}</td>
                                <td v-if="frame_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="ur_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Durchmesser Umlenkrolle:</span>
                                        <span>{{ur_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(ur_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(ur_Disc)}}</td>
                                <td v-if="ur_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(ur_NP)}}</td>
                                <td v-if="ur_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="frEinh_Show==true" class="compact-motor-row">
                                <td class="smallSize ">
                                    <div class="td-grid ZAfont_size">
                                        <span>Einhausung:</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(frEinh_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(frEinh_Disc)}}</td>
                                <td v-if="frEinh_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(frEinh_NP)}}</td>
                                <td v-if="frEinh_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="frEmStop_Show==true" class="compact-motor-row">
                                <td class="smallSize ">
                                    <div class="td-grid ZAfont_size">
                                        <span>Not-Aus-Schalter:</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(frEmStop_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(frEmStop_Disc)}}</td>
                                <td v-if="frEmStop_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(frEmStop_NP)}}</td>
                                <td v-if="frEmStop_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr class="abstand-zeile"></tr>
                            <tr class="sum">
                                <td class="headline_size" style="width:50%">Summe Maschinenrahmen</td>
                                <td class="right paddingColumn ZAfont_size"> </td>
                                <td class="right paddingColumn ZAfont_size"> </td>
                                <td v-if="sumFrame_OnD==false" class="right paddingColumn headline_size">{{isDataANumber(sumFrame)}}</td>
                                <td v-if="sumFrame_OnD==true" class="right paddingColumn headline_size">{{$t('3378')}}</td>
                            </tr>
                        </table>
                        <table v-if="sumInverter_Show==true">
                            <tr class="section-title">
                                <th class="left headline_size" style="font-weight:600; font-size:20px; width:50%">Frequenzumrichter</th>
                                <th class="right">Brutto [€]</th>
                                <th class="right">Rabatt [%]</th>
                                <th class="right">Netto [€]</th>
                            </tr>
                            <tr v-if="fi_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Typ:</span>
                                        <span>{{fi_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(fi_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(fi_Disc)}}</td>
                                <td v-if="fi_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(fi_NP)}}</td>
                                <td v-if="fi_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="inverterPAD_Show==true||inverterMON_Show==true||br_Show==true" class="compact-motor-row">
                                <td class="my_color_00338e headline_size" style="font-weight: 600; font-size: 18px">Zubehör</td>
                                <td class="right paddingColumn ZAfont_size"></td>
                                <td class="right paddingColumn ZAfont_size"></td>
                                <td class="right paddingColumn ZAfont_size"></td>
                            </tr>
                            <tr v-if="inverterPAD_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>ZApad:</span>
                                        <span>{{inverterPAD_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(inverterPAD_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(inverterPAD_Disc)}}</td>
                                <td v-if="inverterPAD_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(inverterPAD_NP)}}</td>
                                <td v-if="inverterPAD_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="inverterMON_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>ZAmon:</span>
                                        <span>{{inverterMON_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(inverterMON_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(inverterMON_Disc)}}</td>
                                <td v-if="inverterMON_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(inverterMON_NP)}}</td>
                                <td v-if="inverterMON_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="br_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Bremswiderstand:</span>
                                        <span>{{br_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(br_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(br_Disc)}}</td>
                                <td v-if="br_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(br_NP)}}</td>
                                <td v-if="br_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="inverterDCP_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>DCP-Leitung:</span>
                                        <span>{{inverterDCP_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(inverterDCP_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(inverterDCP_Disc)}}</td>
                                <td v-if="inverterDCP_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(inverterDCP_NP)}}</td>
                                <td v-if="inverterDCP_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="inverterSTO_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>STO-Leitung:</span>
                                        <span>{{inverterSTO_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(inverterSTO_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(inverterSTO_Disc)}}</td>
                                <td v-if="inverterSTO_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(inverterSTO_NP)}}</td>
                                <td v-if="inverterSTO_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="inverterXOUT_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>XOUT-Leitung:</span>
                                        <span>{{inverterXOUT_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(inverterXOUT_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(inverterXOUT_Disc)}}</td>
                                <td v-if="inverterXOUT_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(inverterXOUT_NP)}}</td>
                                <td v-if="inverterXOUT_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="inverterXIN_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>XIN-Leitung:</span>
                                        <span>{{inverterXIN_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(inverterXIN_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(inverterXIN_Disc)}}</td>
                                <td v-if="inverterXIN_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(inverterXIN_NP)}}</td>
                                <td v-if="inverterXIN_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="inverterNachruestsatz_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Nachruestsatz:</span>
                                        <span>{{inverterNachruestsatz_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(inverterNachruestsatz_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(inverterNachruestsatz_Disc)}}</td>
                                <td v-if="inverterNachruestsatz_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(inverterNachruestsatz_NP)}}</td>
                                <td v-if="inverterNachruestsatz_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="zAsbc_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>ZAsbc:</span>
                                        <span>{{zAsbc_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(zAsbc_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(zAsbc_Disc)}}</td>
                                <td v-if="zAsbc_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(zAsbc_NP)}}</td>
                                <td v-if="zAsbc_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="inverterLeitungssatzZAsbc_Show==true">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Leitungssatz ZAsbc:</span>
                                        <span>{{inverterLeitungssatzZAsbc_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(inverterLeitungssatzZAsbc_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(inverterLeitungssatzZAsbc_Disc)}}</td>
                                <td v-if="inverterLeitungssatzZAsbc_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(inverterLeitungssatzZAsbc_NP)}}</td>
                                <td v-if="inverterLeitungssatzZAsbc_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="inverterBremsenansteuerungsleitungZAsbc_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Bremsenansteuerungsleitung ZAsbc:</span>
                                        <span>{{inverterBremsenansteuerungsleitungZAsbc_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(inverterBremsenansteuerungsleitungZAsbc_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(inverterBremsenansteuerungsleitungZAsbc_Disc)}}</td>
                                <td v-if="inverterBremsenansteuerungsleitungZAsbc_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(inverterBremsenansteuerungsleitungZAsbc_NP)}}</td>
                                <td v-if="inverterBremsenansteuerungsleitungZAsbc_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr class="abstand-zeile"></tr>
                            <tr class="sum">
                                <td class="headline_size" style="width:50%">Summe Frequenzumrichter</td>
                                <td class="right paddingColumn ZAfont_size"> </td>
                                <td class="right paddingColumn ZAfont_size"> </td>
                                <td v-if="sumInverter_OnD==false" class="right paddingColumn headline_size">{{isDataANumber(sumInverter)}}</td>
                                <td v-if="sumInverter_OnD==true" class="right paddingColumn headline_size">{{$t('3378')}}</td>
                            </tr>
                        </table>
                        <table v-if="sumZArec_Show==true">
                            <tr class="section-title">
                                <th class="left headline_size" style="font-weight:600; font-size:20px; width:50%">Rückspeiseeinheit</th>
                                <th class="right">Brutto [€]</th>
                                <th class="right">Rabatt [%]</th>
                                <th class="right">Netto [€]</th>
                            </tr>
                            <tr v-if="zArec_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Typ:</span>
                                        <span>{{zArec_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(zArec_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(zArec_Disc)}}</td>
                                <td v-if="zArec_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(zArec_NP)}}</td>
                                <td v-if="zArec_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="zArecZApad_Show==true||zArecLS_Show==true" class="compact-motor-row">
                                <td class="my_color_00338e headline_size" style="font-weight: 600; font-size: 18px">Zubehör</td>
                                <td class="right paddingColumn ZAfont_size"></td>
                                <td class="right paddingColumn ZAfont_size"></td>
                                <td class="right paddingColumn ZAfont_size"></td>
                            </tr>
                            <tr v-if="zArecZApad_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>ZApad:</span>
                                        <span>{{zArecZApad_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(zArecZApad_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(zArecZApad_Disc)}}</td>
                                <td v-if="zArecZApad_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(zArecZApad_NP)}}</td>
                                <td v-if="zArecZApad_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="zArecLS_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Leitungssatz ZArec:</span>
                                        <span>{{zArecLS_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(zArecLS_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(zArecLS_Disc)}}</td>
                                <td v-if="zArecLS_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(zArecLS_NP)}}</td>
                                <td v-if="zArecLS_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr class="abstand-zeile"></tr>
                            <tr class="sum">
                                <td class="headline_size" style="width:50%">Summe ZArec</td>
                                <td class="right paddingColumn ZAfont_size"> </td>
                                <td class="right paddingColumn ZAfont_size"> </td>
                                <td v-if="sumZArec_OnD==false" class="right paddingColumn headline_size">{{isDataANumber(sumZArec)}}</td>
                                <td v-if="sumZArec_OnD==true" class="right paddingColumn headline_size">{{$t('3378')}}</td>
                            </tr>
                        </table>
                        <table v-if="sumEVAC_Show==true">
                            <tr class="section-title">
                                <th class="left headline_size" style="font-weight:600; font-size:20px; width:50%">Evakuierung</th>
                                <th class="right">Brutto [€]</th>
                                <th class="right">Rabatt [%]</th>
                                <th class="right">Netto [€]</th>
                            </tr>
                            <tr v-if="evac_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Typ:</span>
                                        <span>{{evac_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(evac_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(evac_Disc)}}</td>
                                <td v-if="evac_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(evac_NP)}}</td>
                                <td v-if="evac_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="zArecZApad_Show==true||zArecLS_Show==true" class="compact-motor-row">
                                <td class="my_color_00338e headline_size" style="font-weight: 600; font-size: 18px">Zubehör</td>
                                <td class="right paddingColumn ZAfont_size"></td>
                                <td class="right paddingColumn ZAfont_size"></td>
                                <td class="right paddingColumn ZAfont_size"></td>
                            </tr>
                            <tr v-if="evacBatt_Show==true" class="compact-motor-row">
                                <td class="smallSize">
                                    <div class="td-grid ZAfont_size">
                                        <span>Batteriesatz:</span>
                                        <span>{{evacBatt_Txt}}</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(evacBatt_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(evacBatt_Disc)}}</td>
                                <td v-if="evacBatt_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(evacBatt_NP)}}</td>
                                <td v-if="evacBatt_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="evacCable_Show==true" class="compact-motor-row">
                                <td class="smallSize ">
                                    <div class="td-grid ZAfont_size">
                                        <span>Leitungssatz:</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(evacCable_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(evacCable_Disc)}}</td>
                                <td v-if="evacCable_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(evacCable_NP)}}</td>
                                <td v-if="evacCable_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr v-if="evacControlCable_Show==true" class="compact-motor-row">
                                <td class="smallSize ">
                                    <div class="td-grid ZAfont_size">
                                        <span>Leitungssatz Steuerung:</span>
                                    </div>
                                </td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(evacControlCable_GP)}}</td>
                                <td class="right paddingColumn ZAfont_size">{{isDataANumber(evacControlCable_Disc)}}</td>
                                <td v-if="evacControlCable_OnD==false" class="right paddingColumn ZAfont_size">{{isDataANumber(evacControlCable_NP)}}</td>
                                <td v-if="evacControlCable_OnD==true" class="right paddingColumn ZAfont_size">{{$t('3378')}}</td>
                            </tr>
                            <tr class="abstand-zeile"></tr>
                            <tr class="sum">
                                <td class="headline_size" style="width:50%">Summe Evakuierung</td>
                                <td class="right paddingColumn ZAfont_size"> </td>
                                <td class="right paddingColumn ZAfont_size"> </td>
                                <td v-if="sumEVAC_OnD==false" class="right paddingColumn headline_size">{{isDataANumber(sumEVAC)}}</td>
                                <td v-if="sumEVAC_OnD==true" class="right paddingColumn headline_size">{{$t('3378')}}</td>
                            </tr>
                        </table>
                        <table v-if="sum_Show==true">
                            <tr class="abstand-zeile"></tr>
                            <tr class="sum">
                                <td class="headline_size" style="width:50%">Gesamtsumme</td>
                                <td class="right paddingColumn ZAfont_size"> </td>
                                <td class="right paddingColumn ZAfont_size"> </td>
                                <td v-if="sum_OnD==false" class="right paddingColumn headline_size">{{isDataANumber(sum)}}</td>
                                <td v-if="sum_OnD==true" class="right paddingColumn headline_size">{{$t('3378')}}</td>
                            </tr>
                        </table>
                        <div class="ZAfont_family ZAfont_size" style="margin-top: 20px">
                            Die Preisindikation/Bestellanfrage beinhaltet lediglich die Produktauswahl und Preisinformation entsprechend der
                            technischen Auslegung mittels der von Ihnen genutzten Auslegungssoftware ZAlift Web.
                            Aller Voraussicht nach wird ZIEHL-ABEGG innerhalb von 5 Arbeitstagen nach eigenem Ermessen darüber
                            entscheiden, ob Liefervertrag zu Stande kommt. Sie erhalten hierüber in digitaler Form Nachricht .
                        </div>
                        <div class="ZAfont_family ZAfont_size" style="margin-top: 10px">
                            Für Lieferbedingungen, Verpackung, Zahlungsbedingungen und Gewährleistung gelten die jeweilig vereinbarten
                            Rahmenbedingungen. Im Übrigen gelten die allgemeinen Geschäftsbedingungen der ZIEHL-ABEGG SE
                            (<a class="offer_link" href="https://www.ziehl-abegg.com/agb" target="_blank" rel="noopener noreferrer">www.ziehl-abegg.com/agb</a>).
                        </div>
                        <div class="ZAfont_family ZAfont_size" style="margin-top: 10px">
                            ZIEHL-ABEGG SE weist darauf hin, dass unsere Produkte nur in dem in unserer Betriebsanleitung angegebenen
                            Einsatzbereich verwendet werden dürfen.
                            Die Betriebsanleitung können Sie bereits vor Erhalt der Ware über unsere Webseite
                            <a class="offer_link" href="https://www.ziehl-abegg.com/service/downloads" target="_blank" rel="noopener noreferrer">www.ziehl-abegg.com/service/downloads</a>
                            einsehen
                        </div>
                    </div>
                </div>
                <div class="offer_modal-footer">
                    <div class="offer_modal-content-a4 offer_modal-footer-content">
                        <button class="btn my_btn_standard" @click="closeModal">{{$t('3366')}}</button>
                        <button class="btn my_btn_standard" @click="printOffer">{{$t('1011')}}</button>
                    </div>
                </div>
                <div class="offer_modal-print-footer">
                    ZIEHL-ABEGG SE | Heinz-Ziehl-Straße 74653 Künzelsau | Tel. +49 7940 16-0 | drives@ziehl-abegg.de | www.ziehl-abegg.de
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        props: {
            zlw: '',
            typ: '',
        },
        computed: {
            summary: {
                get() {
                    return this.$store.state.summary.summary;
                }
            },
            elevatorMotor_Machine: {
                get() {
                    return this.summary != null
                        && this.summary.hasOwnProperty('elevatorMotor_Machine')
                        && this.summary.elevatorMotor_Machine != null
                        && this.summary.elevatorMotor_Machine.hasOwnProperty('id')
                        ? this.summary.elevatorMotor_Machine
                        : null;
                }
            },
            elevatorMotor_TractionSheave: {
                get() {
                    return this.summary != null
                        && this.summary.hasOwnProperty('elevatorMotor_TractionSheave')
                        && this.summary.elevatorMotor_TractionSheave != null
                        && this.summary.elevatorMotor_TractionSheave.hasOwnProperty('id')
                        ? this.summary.elevatorMotor_TractionSheave
                        : null;
                }
            },
            suspensionMeans: {
                get() {
                    return this.summary != null
                        && this.summary.hasOwnProperty('suspensionMeans')
                        && this.summary.suspensionMeans != null
                        && this.summary.suspensionMeans.hasOwnProperty('id')
                        ? this.summary.suspensionMeans
                        : null;
                }
            },
            elevatorMotor_TemperatureMonitoring: {
                get() {
                    return this.summary != null
                        && this.summary.hasOwnProperty('elevatorMotor_TemperatureMonitoring')
                        && this.summary.elevatorMotor_TemperatureMonitoring != null
                        && this.summary.elevatorMotor_TemperatureMonitoring.hasOwnProperty('id')
                        ? this.summary.elevatorMotor_TemperatureMonitoring
                        : null;
                }
            },
            elevatorMotor_ForcedVentilation: {
                get() {
                    return this.summary != null
                        && this.summary.hasOwnProperty('elevatorMotor_ForcedVentilation')
                        && this.summary.elevatorMotor_ForcedVentilation != null
                        && this.summary.elevatorMotor_ForcedVentilation.hasOwnProperty('id')
                        ? this.summary.elevatorMotor_ForcedVentilation
                        : null;
                }
            },
            elevatorMotor_Brake: {
                get() {
                    return this.summary != null
                        && this.summary.hasOwnProperty('elevatorMotor_Brake')
                        && this.summary.elevatorMotor_Brake != null
                        && this.summary.elevatorMotor_Brake.hasOwnProperty('id')
                        ? this.summary.elevatorMotor_Brake
                        : null;
                }
            },
            elevatorMotor_Encoder: {
                get() {
                    return this.summary != null
                        && this.summary.hasOwnProperty('elevatorMotor_Encoder')
                        && this.summary.elevatorMotor_Encoder != null
                        && this.summary.elevatorMotor_Encoder.hasOwnProperty('id')
                        ? this.summary.elevatorMotor_Encoder
                        : null;
                }
            },
            motorManual: {
                get() {
                    return this.$store.state.inputsManual.motorManualData != null
                        && this.$store.state.inputsManual.motorManualData.hasOwnProperty('details')
                        && this.$store.state.inputsManual.motorManualData.details.hasOwnProperty('mN_MOT')
                        ? this.$store.state.inputsManual.motorManualData
                        : null;
                }
            },
            motorManualDetails: {
                get() {
                    return this.motorManual != null
                        ? this.motorManual.details
                        : null;
                }
            },
            inverter: {
                get() {
                    return this.summary != null
                        && this.summary.hasOwnProperty('inverter')
                        && this.summary.inverter != null
                        && this.summary.inverter.hasOwnProperty('id')
                        ? this.summary.inverter
                        : null;
                }
            },
            brakeResistor: {
                get() {
                    return this.summary != null
                        && this.summary.hasOwnProperty('brakeResistor')
                        && this.summary.brakeResistor != null
                        && this.summary.brakeResistor.hasOwnProperty('id')
                        ? this.summary.brakeResistor
                        : null;
                }
            },
            powerRecuperationUnit: {
                get() {
                    return this.summary != null
                        && this.summary.hasOwnProperty('powerRecuperationUnit')
                        && this.summary.powerRecuperationUnit != null
                        && this.summary.powerRecuperationUnit.hasOwnProperty('id')
                        ? this.summary.powerRecuperationUnit
                        : null;
                }
            },
            brakeControl: {
                get() {
                    return this.summary != null
                        && this.summary.hasOwnProperty('brakeControl')
                        && this.summary.brakeControl != null
                        && this.summary.brakeControl.hasOwnProperty('id')
                        ? this.summary.brakeControl
                        : null;
                }
            },
            frames: {
                get() {
                    return this.summary != null
                        && this.summary.hasOwnProperty('frames')
                        && this.summary.frames != null
                        && this.summary.frames.hasOwnProperty('id')
                        ? this.summary.frames
                        : null;
                }
            },
            pulleys: {
                get() {
                    return this.summary != null
                        && this.summary.hasOwnProperty('pulleys')
                        && this.summary.pulleys != null
                        && this.summary.pulleys.hasOwnProperty('id')
                        ? this.summary.pulleys
                        : null;
                }
            },
            frameManual: {
                get() {
                    return this.$store.state.inputsManual.frameManualData != null
                        && this.$store.state.inputsManual.frameManualData.hasOwnProperty('details')
                        ? this.$store.state.inputsManual.frameManualData
                        : null;
                }
            },
            pinfo: {
                get() {
                    return this.$store.state.summary.pi;
                }
            },
            pi_information: {
                get() {
                    return this.pinfo != null
                        && this.pinfo.hasOwnProperty('information')
                        ? this.pinfo.information
                        : null;
                }
            },
            pi_motor: {
                get() {
                    return this.pinfo != null
                        && this.pinfo.hasOwnProperty('motor')
                        ? this.pinfo.motor
                        : null;
                }
            },
            pi_frame: {
                get() {
                    return this.pinfo != null
                        && this.pinfo.hasOwnProperty('frame')
                        ? this.pinfo.frame
                        : null;
                }
            },
            pi_inverter: {
                get() {
                    return this.pinfo != null
                        && this.pinfo.hasOwnProperty('inverter')
                        ? this.pinfo.inverter
                        : null;
                }
            },
            pi_evac: {
                get() {
                    return this.pinfo != null
                        && this.pinfo.hasOwnProperty('evac')
                        ? this.pinfo.evac
                        : null;
                }
            },
            pi_ZArec: {
                get() {
                    return this.pinfo != null
                        && this.pinfo.hasOwnProperty('zArec')
                        ? this.pinfo.zArec
                        : null;
                }
            },
            accountName: {
                get() {
                    return this.pi_information != null && this.pi_information.hasOwnProperty('accountName') ? this.pi_information.accountName : '';
                }
            },
            customerName: {
                get() {
                    return this.pi_information != null && this.pi_information.hasOwnProperty('customerName') ? this.pi_information.customerName : '';
                }
            },
            customerNumber: {
                get() {
                    return this.pi_information != null && this.pi_information.hasOwnProperty('customerNumber') ? this.pi_information.customerNumber : '';
                }
            },
            date: {
                get() {
                    return this.pi_information != null && this.pi_information.hasOwnProperty('date') ? this.pi_information.date : '';
                }
            },
            editor: {
                get() {
                    return this.pi_information != null && this.pi_information.hasOwnProperty('editor') ? this.pi_information.editor : '';
                }
            },
            email: {
                get() {
                    return this.pi_information != null && this.pi_information.hasOwnProperty('email') ? this.pi_information.email : '';
                }
            },
            project: {
                get() {
                    return this.pi_information != null && this.pi_information.hasOwnProperty('project') ? this.pi_information.project : '';
                }
            },
            validityDate: {
                get() {
                    return this.pi_information != null && this.pi_information.hasOwnProperty('validityDate') ? this.pi_information.validityDate : '';
                }
            },
            mo_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.elevatorMotor_Machine != null ? this.elevatorMotor_Machine.typeDesignation : ''
                        : this.motorManualDetails != null && this.motorManualDetails.mtyP2 != null ? this.motorManualDetails.mtyP2 : '';
                },
            },
            mo_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor && this.pi_motor.typ ? this.pi_motor.typ.gp : '',
                        this.mo_NP,
                        this.mo_Disc,
                    );
                },
            },
            mo_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('typ') ? this.pi_motor.typ.np : '';
                },
            },
            mo_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('typ') ? this.pi_motor.typ.disc : '';
                },
            },
            mo_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty("typ") ? this.pi_motor.typ.onD : true;
                },
            },
            mo_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('typ') ? this.pi_motor.typ.show : true;
                },
            },
            u_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.elevatorMotor_Machine != null ? this.elevatorMotor_Machine.nominalVoltage : ''
                        : this.motorManualDetails != null && this.motorManualDetails.mu1 != null ? this.motorManualDetails.mu1 : '';;
                },
            },
            u_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor && this.pi_motor.u ? this.pi_motor.u.gp : '',
                        this.u_NP,
                        this.u_Disc,
                    );
                },
            },
            u_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('u') ? this.pi_motor.u_NP : '';
                },
            },
            u_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('u') ? this.pi_motor.u.disc : '';
                },
            },
            u_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('u') ? this.pi_motor.u.onD : true;
                },
            },
            u_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('u') ? this.pi_motor.u.show : true;
                },
            },
            alast_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.elevatorMotor_Machine != null ? this.elevatorMotor_Machine.maximumAxleLoad : ''
                        : '';
                },
            },
            nr_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.elevatorMotor_Machine != null ? this.elevatorMotor_Machine.nominalRotationSpeed : ''
                        : this.motorManualDetails != null && this.motorManualDetails.mnr != null ? this.motorManualDetails.mnr : '';
                },
            },
            ni_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.elevatorMotor_Machine != null ? this.elevatorMotor_Machine.nominalCurrent : ''
                        : this.motorManualDetails != null && this.motorManualDetails.miR1 != null ? this.motorManualDetails.miR1 : '';

                },
            },
            nm_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.elevatorMotor_Machine != null ? this.elevatorMotor_Machine.nominalTorque : ''
                        : this.motorManualDetails != null && this.motorManualDetails.mtR1 != null ? this.motorManualDetails.mtR1 : '';;

                },
            },
            mip_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : this.motorManualDetails != null && this.motorManualDetails.mip != null ? this.motorManualDetails.mip : '';
                },
            },
            mip_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor && this.pi_motor.mip ? this.pi_motor.mip.gp : '',
                        this.mip_NP,
                        this.mip_Disc,
                    );
                },
            },
            mip_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('mip') ? this.pi_motor.mip.np : '';
                },
            },
            mip_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('mip') ? this.pi_motor.mip.disc : '';
                },
            },
            mip_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('mip') ? this.pi_motor.mip.onD : true;
                },
            },
            mip_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('mip') ? this.pi_motor.mip.show : true;
                },
            },
            housV_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.elevatorMotor_Machine != null ? this.elevatorMotor_Machine.mechanicalDesign : ''
                        : '';
                },
            },
            housV_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor != null && this.pi_motor.hasOwnProperty('housV') ? this.pi_motor.housV.gp : '',
                        this.housV_NP,
                        this.housV_Disc,
                    );
                },
            },
            housV_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('housV') ? this.pi_motor.housV.np : '';
                },
            },
            housV_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('housV') ? this.pi_motor.housV.disc : '';
                },
            },
            housV_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('housV') ? this.pi_motor.housV.onD : true;
                },
            },
            housV_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('housV') ? this.pi_motor.housV.show : true;
                },
            },
            motorCblCon_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : '';
                },
            },
            motorCblCon_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor != null && this.pi_motor.hasOwnProperty('motorCblCon') ? this.pi_motor.motorCblCon.gp : '',
                        this.motorCblCon_NP,
                        this.motorCblCon_Disc,
                    );
                },
            },
            motorCblCon_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('motorCblCon') ? this.pi_motor.motorCblCon.np : '';
                },
            },
            motorCblCon_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('motorCblCon') ? this.pi_motor.motorCblCon.disc : '';
                },
            },
            motorCblCon_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('motorCblCon') ? this.pi_motor.motorCblCon.onD : true;
                },
            },
            motorCblCon_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('motorCblCon') ? this.pi_motor.motorCblCon.show : true;
                },
            },
            motorCbl_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : '';
                },
            },
            motorCbl_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor != null && this.pi_motor.hasOwnProperty('motorCbl') ? this.pi_motor.motorCbl.gp : '',
                        this.motorCbl_NP,
                        this.motorCbl_Disc,
                    );
                },
            },
            motorCbl_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('motorCbl') ? this.pi_motor.motorCbl.np : '';
                },
            },
            motorCbl_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('motorCbl') ? this.pi_motor.motorCbl.disc : '';
                },
            },
            motorCbl_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('motorCbl') ? this.pi_motor.motorCbl.onD : true;
                },
            },
            motorCbl_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('motorCbl') ? this.pi_motor.motorCbl.show : true;
                },
            },
            motDis_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : '';
                },
            },
            motDis_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor && this.pi_motor.motDis ? this.pi_motor.motDis.gp : '',
                        this.motDis_NP,
                        this.motDis_Disc,
                    );
                },
            },
            motDis_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('motDis') ? this.pi_motor.motDis.np : '';
                },
            },
            motDis_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('motDis') ? this.pi_motor.motDis.disc : '';
                },
            },
            motDis_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('motDis') ? this.pi_motor.motDis.onD : true;
                },
            },
            motDis_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('motDis') ? this.pi_motor.motDis.show : true;
                },
            },
            td_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.elevatorMotor_TractionSheave != null ? this.elevatorMotor_TractionSheave.diameter : ''
                        : this.motorManualDetails != null && this.motorManualDetails.td != null ? this.motorManualDetails.td : '';
                },
            },
            td_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor != null && this.pi_motor.hasOwnProperty('td') ? this.pi_motor.td.gp : '',
                        this.td_NP,
                        this.td_Disc,
                    );
                },
            },
            td_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('td') ? this.pi_motor.td.np : '';
                },
            },
            td_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('td') ? this.pi_motor.td.disc : '';
                },
            },
            td_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('td') ? this.pi_motor.td.onD : true;
                },
            },
            td_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('td') ? this.pi_motor.td.show : true;
                },
            },
            ra_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.elevatorMotor_TractionSheave != null ? this.elevatorMotor_TractionSheave.grooveDistance : ''
                        : this.motorManualDetails != null && this.motorManualDetails.tdra != null ? this.motorManualDetails.tdra : '';
                },
            },
            ra_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor != null && this.pi_motor.hasOwnProperty('ra') ? this.pi_motor.ra.gp : '',
                        this.ra_NP,
                        this.ra_Disc,
                    );
                },
            },
            ra_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('ra') ? this.pi_motor.ra.np : '';
                },
            },
            ra_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('ra') ? this.pi_motor.ra.disc : '';
                },
            },
            ra_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('ra') ? this.pi_motor.ra.onD : true;
                },
            },
            ra_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('ra') ? this.pi_motor.ra.show : true;
                },
            },
            tbTxt: {
                get() {
                    return this.typ === 't'
                        ? this.elevatorMotor_TractionSheave != null ? this.elevatorMotor_TractionSheave.sheaveWidth : ''
                        : this.motorManualDetails != null && this.motorManualDetails.tb != null ? this.motorManualDetails.tb : '';
                },
            },
            sd_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.suspensionMeans != null
                            ? this.suspensionMeans.beltWidth != null
                                ? this.suspensionMeans.beltWidth
                                : this.suspensionMeans.ropeDiameter2
                            : ''
                        : this.motorManualDetails != null && this.motorManualDetails.tcsd != null ? this.motorManualDetails.tcsd : '';
                },
            },
            ugr_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.elevatorMotor_TractionSheave != null ? this.elevatorMotor_TractionSheave.undercutAngle : ''
                        : this.motorManualDetails != null && this.motorManualDetails.tauwi != null ? this.motorManualDetails.tauwi : '';
                },
            },
            vgr_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.elevatorMotor_TractionSheave != null ? this.elevatorMotor_TractionSheave.vgrooveAngle : ''
                        : this.motorManualDetails != null && this.motorManualDetails.takwi != null ? this.motorManualDetails.takwi : '';
                },
            },
            th_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.elevatorMotor_TractionSheave != null ? this.elevatorMotor_TractionSheave.sheaveHardened : null
                        : null;
                },
            },
            th_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor != null && this.pi_motor.hasOwnProperty('th') ? this.pi_motor.th.gp : '',
                        this.th_NP,
                        this.th_Disc,
                    );
                },
            },
            th_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('th') ? this.pi_motor.th.np : '';
                },
            },
            th_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('th') ? this.pi_motor.th.disc : '';
                },
            },
            th_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('th') ? this.pi_motor.th.onD : true;
                },
            },
            th_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('th') ? this.pi_motor.th.show : true;
                },
            },
            sas_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.elevatorMotor_Machine != null
                            && this.elevatorMotor_Machine.thirdRopeGuardMightBeNecessary != null
                            && this.elevatorMotor_Machine.thirdRopeGuardMightBeNecessary != '0'
                            ? true
                            : null
                        : null;
                },
            },
            sas_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor != null && this.pi_motor.hasOwnProperty('sas') ? this.pi_motor.sas.gp : '',
                        this.sas_NP,
                        this.sas_Disc,
                    );
                },
            },
            sas_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('sas') ? this.pi_motor.sas.np : '';
                },
            },
            sas_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('sas') ? this.pi_motor.sas.disc : '';
                },
            },
            sas_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('sas') ? this.pi_motor.sas.onD : true;
                },
            },
            sas_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('sas') ? this.pi_motor.sas.show : true;
                },
            },
            tklem_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : this.motorManualDetails != null && this.motorManualDetails.mN_TSKL != null ? this.motorManualDetails.mN_TSKL : '';
                },
            },
            tklem_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor != null && this.pi_motor.hasOwnProperty('tklem') ? this.pi_motor.tklem.gp : '',
                        this.tklem_NP,
                        this.tklem_Disc,
                    );
                },
            },
            tklem_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('tklem') ? this.pi_motor.tklem.np : '';
                },
            },
            tklem_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('tklem') ? this.pi_motor.tklem.disc : '';
                },
            },
            tklem_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('tklem') ? this.pi_motor.tklem.onD : true;
                },
            },
            tklem_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('tklem') ? this.pi_motor.tklem.show : true;
                },
            },
            tsabd_Txt: {
                get() {
                    return this.typ === 't'
                        ? false
                        : !!(this.motorManualDetails && this.motorManualDetails.mN_TSAD);
                },
            },
            tsabd_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor != null && this.pi_motor.hasOwnProperty('tsabd') ? this.pi_motor.tsabd.gp : '',
                        this.tsabd_NP,
                        this.tsabd_Disc,
                    );
                },
            },
            tsabd_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('tsabd') ? this.pi_motor.tsabd.np : '';
                },
            },
            tsabd_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('tsabd') ? this.pi_motor.tsabd.disc : '';
                },
            },
            tsabd_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('tsabd') ? this.pi_motor.tsabd.onD : true;
                },
            },
            tsabd_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('tsabd') ? this.pi_motor.tsabd.show : true;
                },
            },
            tsabD1_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : this.motorManualDetails != null && this.motorManualDetails.mN_TSAD != null ? this.motorManualDetails.mN_TSAD : '';
                },
            },
            tsabD1_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor != null && this.pi_motor.hasOwnProperty('tsabD1') ? this.pi_motor.tsabD1.gp : '',
                        this.tsabD1_NP,
                        this.tsabD1_Disc,
                    );
                },
            },
            tsabD1_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('tsabD1') ? this.pi_motor.tsabD1.np : '';
                },
            },
            tsabD1_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('tsabD1') ? this.pi_motor.tsabD1.disc : '';
                },
            },
            tsabD1_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('tsabD1') ? this.pi_motor.tsabD1.onD : true;
                },
            },
            tsabD1_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('tsabD1') ? this.pi_motor.tsabD1.show : true;
                },
            },
            tm_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.elevatorMotor_TemperatureMonitoring != null ? this.elevatorMotor_TemperatureMonitoring.typeDesignation : ''
                        : this.motorManualDetails != null && this.motorManualDetails.msart != null ? this.motorManualDetails.msart : '';
                },
            },
            tm_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor != null && this.pi_motor.hasOwnProperty('tm') ? this.pi_motor.tm.gp : '',
                        this.tm_NP,
                        this.tm_Disc,
                    );
                },
            },
            tm_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('tm') ? this.pi_motor.tm.np : '';
                },
            },
            tm_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('tm') ? this.pi_motor.tm.disc : '';
                },
            },
            tm_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('tm') ? this.pi_motor.tm.onD : true;
                },
            },
            tm_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('tm') ? this.pi_motor.tm.show : true;
                },
            },
            fan_Txt: {
                get() {
                    return this.typ === 't'
                        ? !!(this.elevatorMotor_ForcedVentilation && (this.elevatorMotor_ForcedVentilation.necessary || this.elevatorMotor_ForcedVentilation.selected))
                        : !!(this.motorManualDetails && this.motorManualDetails.mfbtyp && this.motorManualDetails.mfbtyp !== 'ohne');
                },
            },
            fan_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor != null && this.pi_motor.hasOwnProperty('fan') ? this.pi_motor.fan.gp : '',
                        this.fan_NP,
                        this.fan_Disc,
                    );
                },
            },
            fan_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('fan') ? this.pi_motor.fan.np : '';
                },
            },
            fan_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('fan') ? this.pi_motor.fan.disc : '';
                },
            },
            fan_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('fan') ? this.pi_motor.fan.onD : true;
                },
            },
            fan_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('fan') ? this.pi_motor.fan.show : true;
                },
            },
            bhl_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.elevatorMotor_Brake != null ? this.elevatorMotor_Brake.mechanicalRelease : ''
                        : this.motorManualDetails != null && this.motorManualDetails.bhl != null ? this.motorManualDetails.bhl : '';
                },
            },
            bhl_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor != null && this.pi_motor.hasOwnProperty('bhl') ? this.pi_motor.bhl.gp : '',
                        this.bhl_NP,
                        this.bhl_Disc,
                    );
                },
            },
            bhl_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('bhl') ? this.pi_motor.bhl.np : '';
                },
            },
            bhl_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('bhl') ? this.pi_motor.bhl.disc : '';
                },
            },
            bhl_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('bhl') ? this.pi_motor.bhl.onD : true;
                },
            },
            bhl_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('bhl') ? this.pi_motor.bhl.show : true;
                },
            },
            bowden_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : '';
                },
            },
            bowden_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor != null && this.pi_motor.hasOwnProperty('bowden') ? this.pi_motor.bowden.gp : '',
                        this.bowden_NP,
                        this.bowden_Disc,
                    );
                },
            },
            bowden_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('bowden') ? this.pi_motor.bowden.np : '';
                },
            },
            bowden_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('bowden') ? this.pi_motor.bowden.disc : '';
                },
            },
            bowden_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('bowden') ? this.pi_motor.bowden.onD : true;
                },
            },
            bowden_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('bowden') ? this.pi_motor.bowden.show : true;
                },
            },
            ksich_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.elevatorMotor_Brake != null ? this.elevatorMotor_Brake.releaseMonitoring : ''
                        : this.motorManualDetails != null && this.motorManualDetails.bksich != null ? this.motorManualDetails.bksich : '';
                },
            },
            ksich_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor != null && this.pi_motor.hasOwnProperty('ksich') ? this.pi_motor.ksich.gp : '',
                        this.ksich_NP,
                        this.ksich_Disc,
                    );
                },
            },
            ksich_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('ksich') ? this.pi_motor.ksich.np : '';
                },
            },
            ksich_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('ksich') ? this.pi_motor.ksich.disc : '';
                },
            },
            ksich_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('ksich') ? this.pi_motor.ksich.onD : true;
                },
            },
            ksich_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('ksich') ? this.pi_motor.ksich.show : true;
                },
            },
            enc_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.elevatorMotor_Encoder != null ? this.elevatorMotor_Encoder.typeDesignation : ''
                        : this.motorManualDetails != null && this.motorManualDetails.gtyp != null ? this.motorManualDetails.gtyp : '';
                },
            },
            enc_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_motor != null && this.pi_motor.hasOwnProperty('enc') ? this.pi_motor.enc.gp : '',
                        this.enc_NP,
                        this.enc_Disc,
                    );
                },
            },
            enc_NP: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('enc') ? this.pi_motor.enc.np : '';
                },
            },
            enc_Disc: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('enc') ? this.pi_motor.enc.disc : '';
                },
            },
            enc_OnD: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('enc') ? this.pi_motor.enc.onD : true;
                },
            },
            enc_Show: {
                get() {
                    return this.pi_motor != null && this.pi_motor.hasOwnProperty('enc') ? this.pi_motor.enc.show : true;
                },
            },
            sumMotor: {
                get() {
                    return this.pinfo != null && this.pinfo.hasOwnProperty('sumMotor') && this.pinfo.sumMotor != null ? this.pinfo.sumMotor.np : '';
                },
            },
            sumMotor_OnD: {
                get() {
                    return this.pinfo != null && this.pinfo.hasOwnProperty('sumMotor') && this.pinfo.sumMotor != null ? this.pinfo.sumMotor.onD : true;
                },
            },
            sumMotor_Show: {
                get() {
                    return this.pinfo != null && this.pinfo.hasOwnProperty('sumMotor') && this.pinfo.sumMotor != null ? this.pinfo.sumMotor.show : true;
                },
            },
            fi_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.inverter != null ? this.inverter.typeDesignation : ''
                        : this.$store.state.FI.FI_ModelUI_selected == null ? this.$store.state.FI.FI_Model_selected : this.$store.state.FI.FI_ModelUI_selected;
                },
            },
            fi_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_inverter && this.pi_inverter.fi ? this.pi_inverter.fi.gp : '',
                        this.fi_NP,
                        this.fi_Disc,
                    );
                },
            },
            fi_NP: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('fi') ? this.pi_inverter.fi.np : '';
                },
            },
            fi_Disc: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('fi') ? this.pi_inverter.fi.disc : '';
                },
            },
            fi_OnD: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('fi') ? this.pi_inverter.fi.onD : true;
                },
            },
            fi_Show: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('fi') ? this.pi_inverter.fi.show : true;
                },
            },
            br_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.brakeResistor != null ? this.brakeResistor.typeDesignation : ''
                        : this.$store.state.FI.FI_BRUI_selected == null ? this.$store.state.FI.FI_BR_selected : this.$store.state.FI.FI_BRUI_selected;
                },
            },
            br_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_inverter != null && this.pi_inverter.hasOwnProperty('br') ? this.pi_inverter.br.gp : '',
                        this.br_NP,
                        this.br_Disc,
                    );
                },
            },
            br_NP: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('br') ? this.pi_inverter.br.np : '';
                },
            },
            br_Disc: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('br') ? this.pi_inverter.br.disc : '';
                },
            },
            br_OnD: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('br') ? this.pi_inverter.br.onD : true;
                },
            },
            br_Show: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('br') ? this.pi_inverter.br.show : true;
                },
            },
            zAsbc_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.brakeControl != null ? this.brakeControl.typeDesignation : ''
                        : this.$store.state.FI.FI_ZAsbcUI_selected == null ? this.$store.state.FI.FI_ZAsbc_selected : this.$store.state.FI.FI_ZAsbcUI_selected;
                },
            },
            zAsbc_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_inverter != null && this.pi_inverter.hasOwnProperty('zAsbc') ? this.pi_inverter.zAsbc.gp : '',
                        this.zAsbc_NP,
                        this.zAsbc_Disc,
                    );
                },
            },
            zAsbc_NP: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('zAsbc') ? this.pi_inverter.zAsbc.np : '';
                },
            },
            zAsbc_Disc: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('zAsbc') ? this.pi_inverter.zAsbc.disc : '';
                },
            },
            zAsbc_OnD: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('zAsbc') ? this.pi_inverter.zAsbc.onD : true;
                },
            },
            zAsbc_Show: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('zAsbc') ? this.pi_inverter.zAsbc.show : true;
                },
            },

            inverterPAD_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : this.$store.state.FI.FI_PADUI_selected == null ? this.$store.state.FI.FI_PAD_selected : this.$store.state.FI.FI_PADUI_selected;
                },
            },
            inverterPAD_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_inverter != null && this.pi_inverter.hasOwnProperty('pad') ? this.pi_inverter.pad.gp : '',
                        this.inverterPAD_NP,
                        this.inverterPAD_Disc,
                    );
                },
            },
            inverterPAD_NP: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('pad') ? this.pi_inverter.pad.np : '';
                },
            },
            inverterPAD_Disc: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('pad') ? this.pi_inverter.pad.disc : '';
                },
            },
            inverterPAD_OnD: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('pad') ? this.pi_inverter.pad.onD : true;
                },
            },
            inverterPAD_Show: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('pad') ? this.pi_inverter.pad.show : true;
                },
            },
            inverterMON_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : this.$store.state.FI.FI_MONUI_selected == null ? this.$store.state.FI.FI_MON_selected : this.$store.state.FI.FI_MONUI_selected;
                },
            },
            inverterMON_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_inverter != null && this.pi_inverter.hasOwnProperty('mon') ? this.pi_inverter.mon.gp : '',
                        this.inverterMON_NP,
                        this.inverterMON_Disc,
                    );
                },
            },
            inverterMON_NP: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('mon') ? this.pi_inverter.mon.np : '';
                },
            },
            inverterMON_Disc: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('mon') ? this.pi_inverter.mon.disc : '';
                },
            },
            inverterMON_OnD: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('mon') ? this.pi_inverter.mon.onD : true;
                },
            },
            inverterMON_Show: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('mon') ? this.pi_inverter.mon.show : true;
                },
            },
            inverterNachruestsatz_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : this.$store.state.FI.FI_NachruestsatzUI_selected == null ? this.$store.state.FI.FI_Nachruestsatz_selected : this.$store.state.FI.FI_NachruestsatzUI_selected;
                },
            },
            inverterNachruestsatz_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_inverter != null && this.pi_inverter.hasOwnProperty('nachruestsatz') ? this.pi_inverter.nachruestsatz.gp : '',
                        this.inverterNachruestsatz_NP,
                        this.inverterNachruestsatz_Disc,
                    );
                },
            },
            inverterNachruestsatz_NP: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('nachruestsatz') ? this.pi_inverter.nachruestsatz.np : '';
                },
            },
            inverterNachruestsatz_Disc: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('nachruestsatz') ? this.pi_inverter.nachruestsatz.disc : '';
                },
            },
            inverterNachruestsatz_OnD: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('nachruestsatz') ? this.pi_inverter.nachruestsatz.onD : true;
                },
            },
            inverterNachruestsatz_Show: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('nachruestsatz') ? this.pi_inverter.nachruestsatz.show : true;
                },
            },
            inverterDCP_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : this.$store.state.FI.FI_DCPUI_selected == null ? this.$store.state.FI.FI_DCP_selected : this.$store.state.FI.FI_DCPUI_selected;
                },
            },
            inverterDCP_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_inverter != null && this.pi_inverter.hasOwnProperty('dcp') ? this.pi_inverter.dcp.gp : '',
                        this.inverterDCP_NP,
                        this.inverterDCP_Disc,
                    );
                },
            },
            inverterDCP_NP: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('dcp') ? this.pi_inverter.dcp.np : '';
                },
            },
            inverterDCP_Disc: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('dcp') ? this.pi_inverter.dcp.disc : '';
                },
            },
            inverterDCP_OnD: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('dcp') ? this.pi_inverter.dcp.onD : true;
                },
            },
            inverterDCP_Show: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('dcp') ? this.pi_inverter.dcp.show : true;
                },
            },
            inverterSTO_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : this.$store.state.FI.FI_STOUI_selected == null ? this.$store.state.FI.FI_STO_selected : this.$store.state.FI.FI_STOUI_selected;
                },
            },
            inverterSTO_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_inverter != null && this.pi_inverter.hasOwnProperty('sto') ? this.pi_inverter.sto.gp : '',
                        this.inverterSTO_NP,
                        this.inverterSTO_Disc,
                    );
                },
            },
            inverterSTO_NP: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('sto') ? this.pi_inverter.sto.np : '';
                },
            },
            inverterSTO_Disc: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('sto') ? this.pi_inverter.sto.disc : '';
                },
            },
            inverterSTO_OnD: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('sto') ? this.pi_inverter.sto.onD : true;
                },
            },
            inverterSTO_Show: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('sto') ? this.pi_inverter.sto.show : true;
                },
            },
            inverterXOUT_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : this.$store.state.FI.FI_XOUTUI_selected == null ? this.$store.state.FI.FI_XOUT_selected : this.$store.state.FI.FI_XOUTUI_selected;
                },
            },
            inverterXOUT_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_inverter != null && this.pi_inverter.hasOwnProperty('xout') ? this.pi_inverter.xout.gp : '',
                        this.inverterXOUT_NP,
                        this.inverterXOUT_Disc,
                    );
                },
            },
            inverterXOUT_NP: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('xout') ? this.pi_inverter.xout.np : '';
                },
            },
            inverterXOUT_Disc: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('xout') ? this.pi_inverter.xout.disc : '';
                },
            },
            inverterXOUT_OnD: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('xout') ? this.pi_inverter.xout.onD : true;
                },
            },
            inverterXOUT_Show: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('xout') ? this.pi_inverter.xout.show : true;
                },
            },
            inverterXIN_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : this.$store.state.FI.FI_XINUI_selected == null ? this.$store.state.FI.FI_XIN_selected : this.$store.state.FI.FI_XINUI_selected;
                },
            },
            inverterXIN_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_inverter != null && this.pi_inverter.hasOwnProperty('xin') ? this.pi_inverter.xin.gp : '',
                        this.inverterXIN_NP,
                        this.inverterXIN_Disc,
                    );
                },
            },
            inverterXIN_NP: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('xin') ? this.pi_inverter.xin.np : '';
                },
            },
            inverterXIN_Disc: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('xin') ? this.pi_inverter.xin.disc : '';
                },
            },
            inverterXIN_OnD: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('xin') ? this.pi_inverter.xin.onD : true;
                },
            },
            inverterXIN_Show: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('xin') ? this.pi_inverter.xin.show : true;
                },
            },
            inverterLeitungssatzZAsbc_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : this.$store.state.FI.FI_ZAsbc_LSUI_selected == null ? this.$store.state.FI.FI_ZAsbc_LS_selected : this.$store.state.FI.FI_ZAsbc_LSUI_selected;
                },
            },
            inverterLeitungssatzZAsbc_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_inverter != null && this.pi_inverter.hasOwnProperty('leitungssatz_ZAsbc') ? this.pi_inverter.leitungssatz_ZAsbc.gp : '',
                        this.inverterLeitungssatzZAsbc_NP,
                        this.inverterLeitungssatzZAsbc_Disc,
                    );
                },
            },
            inverterLeitungssatzZAsbc_NP: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('leitungssatz_ZAsbc') ? this.pi_inverter.leitungssatz_ZAsbc.np : '';
                },
            },
            inverterLeitungssatzZAsbc_Disc: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('leitungssatz_ZAsbc') ? this.pi_inverter.leitungssatz_ZAsbc.disc : '';
                },
            },
            inverterLeitungssatzZAsbc_OnD: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('leitungssatz_ZAsbc') ? this.pi_inverter.leitungssatz_ZAsbc.onD : true;
                },
            },
            inverterLeitungssatzZAsbc_Show: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('leitungssatz_ZAsbc') ? this.pi_inverter.leitungssatz_ZAsbc.show : true;
                },
            },
            inverterBremsenansteuerungsleitungZAsbc_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : this.$store.state.FI.FI_ZAsbc_LSBAUI_selected == null ? this.$store.state.FI.FI_ZAsbc_LSBA_selected : this.$store.state.FI.FI_ZAsbc_LSBAUI_selected;
                },
            },
            inverterBremsenansteuerungsleitungZAsbc_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_inverter != null && this.pi_inverter.hasOwnProperty('bremsenansteuerungsleitung_ZAsbc') ? this.pi_inverter.bremsenansteuerungsleitung_ZAsbc.gp : '',
                        this.inverterBremsenansteuerungsleitungZAsbc_NP,
                        this.inverterBremsenansteuerungsleitungZAsbc_Disc,
                    );
                },
            },
            inverterBremsenansteuerungsleitungZAsbc_NP: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('bremsenansteuerungsleitung_ZAsbc') ? this.pi_inverter.bremsenansteuerungsleitung_ZAsbc.np : '';
                },
            },
            inverterBremsenansteuerungsleitungZAsbc_Disc: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('bremsenansteuerungsleitung_ZAsbc') ? this.pi_inverter.bremsenansteuerungsleitung_ZAsbc.disc : '';
                },
            },
            inverterBremsenansteuerungsleitungZAsbc_OnD: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('bremsenansteuerungsleitung_ZAsbc') ? this.pi_inverter.bremsenansteuerungsleitung_ZAsbc.onD : true;
                },
            },
            inverterBremsenansteuerungsleitungZAsbc_Show: {
                get() {
                    return this.pi_inverter != null && this.pi_inverter.hasOwnProperty('bremsenansteuerungsleitung_ZAsbc') ? this.pi_inverter.bremsenansteuerungsleitung_ZAsbc.show : true;
                },
            },
            sumInverter: {
                get() {
                    return this.pinfo != null && this.pinfo.hasOwnProperty('sumInverter') && this.pinfo.sumInverter != null ? this.pinfo.sumInverter.np : '';
                },
            },
            sumInverter_OnD: {
                get() {
                    return this.pinfo != null && this.pinfo.hasOwnProperty('sumInverter') && this.pinfo.sumInverter != null ? this.pinfo.sumInverter.onD : true;
                },
            },
            sumInverter_Show: {
                get() {
                    return this.pinfo != null && this.pinfo.hasOwnProperty('sumInverter') && this.pinfo.sumInverter != null ? this.pinfo.sumInverter.show : true;
                },
            },
            zArec_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.powerRecuperationUnit != null ? this.powerRecuperationUnit.typeDesignation : ''
                        : this.$store.state.ZArec.ZArec_TypUI_select == null ? this.$store.state.ZArec.ZArec_Typ_select : this.$store.state.ZArec.ZArec_TypUI_select;
                },
            },
            zArec_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_ZArec != null && this.pi_ZArec.hasOwnProperty('typ') ? this.pi_ZArec.typ.gp : '',
                        this.zArec_NP,
                        this.zArec_Disc,
                    );
                },
            },
            zArec_NP: {
                get() {
                    return this.pi_ZArec != null && this.pi_ZArec.hasOwnProperty('typ') ? this.pi_ZArec.typ.np : '';
                },
            },
            zArec_Disc: {
                get() {
                    return this.pi_ZArec != null && this.pi_ZArec.hasOwnProperty('typ') ? this.pi_ZArec.typ.disc : '';
                },
            },
            zArec_OnD: {
                get() {
                    return this.pi_ZArec != null && this.pi_ZArec.hasOwnProperty('typ') ? this.pi_ZArec.typ.onD : true;
                },
            },
            zArec_Show: {
                get() {
                    return this.pi_ZArec != null && this.pi_ZArec.hasOwnProperty('typ') ? this.pi_ZArec.typ.show : true;
                },
            },
            zArecLS_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : this.$store.state.ZArec.ZArec_LSUI_select == null ? this.$store.state.ZArec.ZArec_LS_select : this.$store.state.ZArec.ZArec_LSUI_select;
                },
            },
            zArecLS_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_ZArec != null && this.pi_ZArec.hasOwnProperty('ls') ? this.pi_ZArec.ls.gp : '',
                        this.zArecLS_NP,
                        this.zArecLS_Disc,
                    );
                },
            },
            zArecLS_NP: {
                get() {
                    return this.pi_ZArec != null && this.pi_ZArec.hasOwnProperty('ls') ? this.pi_ZArec.ls.np : '';
                },
            },
            zArecLS_Disc: {
                get() {
                    return this.pi_ZArec != null && this.pi_ZArec.hasOwnProperty('ls') ? this.pi_ZArec.ls.disc : '';
                },
            },
            zArecLS_OnD: {
                get() {
                    return this.pi_ZArec != null && this.pi_ZArec.hasOwnProperty('ls') ? this.pi_ZArec.ls.onD : true;
                },
            },
            zArecLS_Show: {
                get() {
                    return this.pi_ZArec != null && this.pi_ZArec.hasOwnProperty('ls') ? this.pi_ZArec.ls.show : true;
                },
            },
            zArecZApad_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : this.$store.state.ZArec.ZArec_ZApadUI_select == null ? this.$store.state.ZArec.ZArec_ZApad_select : this.$store.state.ZArec.ZArec_ZApadUI_select;
                },
            },
            zArecZApad_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_ZArec != null && this.pi_ZArec.hasOwnProperty('zApad') ? this.pi_ZArec.zApad.gp : '',
                        this.zArecZApad_NP,
                        this.zArecZApad_Disc,
                    );
                },
            },
            zArecZApad_NP: {
                get() {
                    return this.pi_ZArec != null && this.pi_ZArec.hasOwnProperty('zApad') ? this.pi_ZArec.zApad.np : '';
                },
            },
            zArecZApad_Disc: {
                get() {
                    return this.pi_ZArec != null && this.pi_ZArec.hasOwnProperty('zApad') ? this.pi_ZArec.zApad.disc : '';
                },
            },
            zArecZApad_OnD: {
                get() {
                    return this.pi_ZArec != null && this.pi_ZArec.hasOwnProperty('zApad') ? this.pi_ZArec.zApad.onD : true;
                },
            },
            zArecZApad_Show: {
                get() {
                    return this.pi_ZArec != null && this.pi_ZArec.hasOwnProperty('zApad') ? this.pi_ZArec.zApad.show : true;
                },
            },
            sumZArec: {
                get() {
                    return this.pinfo != null && this.pinfo.hasOwnProperty('sumZArec') && this.pinfo.sumZArec != null ? this.pinfo.sumZArec.np : '';
                },
            },
            sumZArec_OnD: {
                get() {
                    return this.pinfo != null && this.pinfo.hasOwnProperty('sumZArec') && this.pinfo.sumZArec != null ? this.pinfo.sumZArec.onD : true;
                },
            },
            sumZArec_Show: {
                get() {
                    return this.pinfo != null && this.pinfo.hasOwnProperty('sumZArec') && this.pinfo.sumZArec != null ? this.pinfo.sumZArec.show : true;
                },
            },
            frame_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.frames != null ? this.frames.type : ''
                        : this.frameManual.details.fratyp != null ? this.frameManual.details.fratyp : '';
                },
            },
            frame_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_frame != null && this.pi_frame.hasOwnProperty('typ') ? this.pi_frame.typ.gp : '',
                        this.frame_NP,
                        this.frame_Disc,
                    );
                },
            },
            frame_NP: {
                get() {
                    return this.pi_frame != null && this.pi_frame.hasOwnProperty('typ') ? this.pi_frame.typ.np : '';
                },
            },
            frame_Disc: {
                get() {
                    return this.pi_frame != null && this.pi_frame.hasOwnProperty('typ') ? this.pi_frame.typ.disc : '';
                },
            },
            frame_OnD: {
                get() {
                    return this.pi_frame != null && this.pi_frame.hasOwnProperty('typ') ? this.pi_frame.typ.onD : true;
                },
            },
            frame_Show: {
                get() {
                    return this.pi_frame != null && this.pi_frame.hasOwnProperty('typ') ? this.pi_frame.typ.show : true;
                },
            },
            ur_Txt: {
                get() {
                    return this.typ === 't'
                        ? this.pulleys != null ? [this.pulleys.diameter, '/', this.pulleys.sheaveWidth, '/', this.pulleys.grooveDistance, '/', this.pulleys.numberOfGrooves, 'x', this.pulleys.grooveDiameterMinimum].join("") : ''
                        : this.frameManual.details.urd != null ? this.frameManual.details.urd : '';
                },
            },
            ur_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_frame != null && this.pi_frame.hasOwnProperty('ur') ? this.pi_frame.ur.gp : '',
                        this.ur_NP,
                        this.ur_Disc,
                    );
                },
            },
            ur_NP: {
                get() {
                    return this.pi_frame != null && this.pi_frame.hasOwnProperty('ur') ? this.pi_frame.ur.np : '';
                },
            },
            ur_Disc: {
                get() {
                    return this.pi_frame != null && this.pi_frame.hasOwnProperty('ur') ? this.pi_frame.ur.disc : '';
                },
            },
            ur_OnD: {
                get() {
                    return this.pi_frame != null && this.pi_frame.hasOwnProperty('ur') ? this.pi_frame.ur.onD : true;
                },
            },
            ur_Show: {
                get() {
                    return this.pi_frame != null && this.pi_frame.hasOwnProperty('ur') ? this.pi_frame.ur.show : true;
                },
            },
            frEinh_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_frame != null && this.pi_frame.hasOwnProperty('frEinh') ? this.pi_frame.frEinh.gp : '',
                        this.frEinh_NP,
                        this.frEinh_Disc,
                    );
                },
            },
            frEinh_NP: {
                get() {
                    return this.pi_frame != null && this.pi_frame.hasOwnProperty('frEinh') ? this.pi_frame.frEinh.np : '';
                },
            },
            frEinh_Disc: {
                get() {
                    return this.pi_frame != null && this.pi_frame.hasOwnProperty('frEinh') ? this.pi_frame.frEinh.disc : '';
                },
            },
            frEinh_OnD: {
                get() {
                    return this.pi_frame != null && this.pi_frame.hasOwnProperty('frEinh') ? this.pi_frame.frEinh.onD : true;
                },
            },
            frEinh_Show: {
                get() {
                    return this.pi_frame != null && this.pi_frame.hasOwnProperty('frEinh') ? this.pi_frame.frEinh.show : true;
                },
            },
            frEmStop_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_frame != null && this.pi_frame.hasOwnProperty('frEmStop') ? this.pi_frame.frEmStop.gp : '',
                        this.frEmStop_NP,
                        this.frEmStop_Disc,
                    );
                },
            },
            frEmStop_NP: {
                get() {
                    return this.pi_frame != null && this.pi_frame.hasOwnProperty('frEmStop') ? this.pi_frame.frEmStop.np : '';
                },
            },
            frEmStop_Disc: {
                get() {
                    return this.pi_frame != null && this.pi_frame.hasOwnProperty('frEmStop') ? this.pi_frame.frEmStop.disc : '';
                },
            },
            frEmStop_OnD: {
                get() {
                    return this.pi_frame != null && this.pi_frame.hasOwnProperty('frEmStop') ? this.pi_frame.frEmStop.onD : true;
                },
            },
            frEmStop_Show: {
                get() {
                    return this.pi_frame != null && this.pi_frame.hasOwnProperty('frEmStop') ? this.pi_frame.frEmStop.show : true;
                },
            },
            sumFrame: {
                get() {
                    return this.pinfo != null && this.pinfo.hasOwnProperty('sumFrame') && this.pinfo.sumFrame != null ? this.pinfo.sumFrame.np : '';
                },
            },
            sumFrame_OnD: {
                get() {
                    return this.pinfo != null && this.pinfo.hasOwnProperty('sumFrame') && this.pinfo.sumFrame != null ? this.pinfo.sumFrame.onD : true;
                },
            },
            sumFrame_Show: {
                get() {
                    return this.pinfo != null && this.pinfo.hasOwnProperty('sumFrame') && this.pinfo.sumFrame != null ? this.pinfo.sumFrame.show : true;
                },
            },
            evac_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : this.$store.state.EVAC.EVAC_TypUI_select == null ? this.$store.state.EVAC.EVAC_Typ_select : this.$store.state.EVAC.EVAC_TypUI_select;
                },
            },
            evac_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_evac != null && this.pi_evac.hasOwnProperty('typ') ? this.pi_evac.typ.gp : '',
                        this.evac_NP,
                        this.evac_Disc,
                    );
                },
            },
            evac_NP: {
                get() {
                    return this.pi_evac != null && this.pi_evac.hasOwnProperty('typ') ? this.pi_evac.typ.np : '';
                },
            },
            evac_Disc: {
                get() {
                    return this.pi_evac != null && this.pi_evac.hasOwnProperty('typ') ? this.pi_evac.typ.disc : '';
                },
            },
            evac_OnD: {
                get() {
                    return this.pi_evac != null && this.pi_evac.hasOwnProperty('typ') ? this.pi_evac.typ.onD : true;
                },
            },
            evac_Show: {
                get() {
                    return this.pi_evac != null && this.pi_evac.hasOwnProperty('typ') ? this.pi_evac.typ.show : true;
                },
            },
            evacBatt_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : this.$store.state.EVAC.EVAC_BattUI_select == null ? this.$store.state.EVAC.EVAC_Batt_select : this.$store.state.EVAC.EVAC_BattUI_select;
                },
            },
            evacBatt_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_evac != null && this.pi_evac.hasOwnProperty('batt') ? this.pi_evac.batt.gp : '',
                        this.evacBatt_NP,
                        this.evacBatt_Disc,
                    );
                },
            },
            evacBatt_NP: {
                get() {
                    return this.pi_evac != null && this.pi_evac.hasOwnProperty('batt') ? this.pi_evac.batt.np : '';
                },
            },
            evacBatt_Disc: {
                get() {
                    return this.pi_evac != null && this.pi_evac.hasOwnProperty('batt') ? this.pi_evac.batt.disc : '';
                },
            },
            evacBatt_OnD: {
                get() {
                    return this.pi_evac != null && this.pi_evac.hasOwnProperty('batt') ? this.pi_evac.batt.onD : true;
                },
            },
            evacBatt_Show: {
                get() {
                    return this.pi_evac != null && this.pi_evac.hasOwnProperty('batt') ? this.pi_evac.batt.show : true;
                },
            },
            evacCable_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : this.$store.state.EVAC.EVAC_CableUI_select == null ? this.$store.state.EVAC.EVAC_Cable_select : this.$store.state.EVAC.EVAC_CableUI_select;
                },
            },
            evacCable_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_evac != null && this.pi_evac.hasOwnProperty('cable') ? this.pi_evac.cable.gp : '',
                        this.evacCable_NP,
                        this.evacCable_Disc,
                    );
                },
            },
            evacCable_NP: {
                get() {
                    return this.pi_evac != null && this.pi_evac.hasOwnProperty('cable') ? this.pi_evac.cable.np : '';
                },
            },
            evacCable_Disc: {
                get() {
                    return this.pi_evac != null && this.pi_evac.hasOwnProperty('cable') ? this.pi_evac.cable.disc : '';
                },
            },
            evacCable_OnD: {
                get() {
                    return this.pi_evac != null && this.pi_evac.hasOwnProperty('cable') ? this.pi_evac.cable.onD : true;
                },
            },
            evacCable_Show: {
                get() {
                    return this.pi_evac != null && this.pi_evac.hasOwnProperty('cable') ? this.pi_evac.cable.show : true;
                },
            },
            evacControlCable_Txt: {
                get() {
                    return this.typ === 't'
                        ? ''
                        : this.$store.state.EVAC.EVAC_Control_CableUI_select == null ? this.$store.state.EVAC.EVAC_Control_Cable_select : this.$store.state.EVAC.EVAC_Control_CableUI_select;
                },
            },
            evacControlCable_GP: {
                get() {
                    return this.getGpValue(
                        this.pi_evac != null && this.pi_evac.hasOwnProperty('controlCable') ? this.pi_evac.controlCable.gp : '',
                        this.evacControlCable_NP,
                        this.evacControlCable_Disc,
                    );
                },
            },
            evacControlCable_NP: {
                get() {
                    return this.pi_evac != null && this.pi_evac.hasOwnProperty('controlCable') ? this.pi_evac.controlCable.np : '';
                },
            },
            evacControlCable_Disc: {
                get() {
                    return this.pi_evac != null && this.pi_evac.hasOwnProperty('controlCable') ? this.pi_evac.controlCable.disc : '';
                },
            },
            evacControlCable_OnD: {
                get() {
                    return this.pi_evac != null && this.pi_evac.hasOwnProperty('controlCable') ? this.pi_evac.controlCable.onD : true;
                },
            },
            evacControlCable_Show: {
                get() {
                    return this.pi_evac != null && this.pi_evac.hasOwnProperty('controlCable') ? this.pi_evac.controlCable.show : true;
                },
            },
            sumEVAC: {
                get() {
                    return this.pinfo != null && this.pinfo.hasOwnProperty('sumEVAC') && this.pinfo.sumEVAC != null ? this.pinfo.sumEVAC.np : '';
                },
            },
            sumEVAC_OnD: {
                get() {
                    return this.pinfo != null && this.pinfo.hasOwnProperty('sumEVAC') && this.pinfo.sumEVAC != null ? this.pinfo.sumEVAC.onD : true;
                },
            },
            sumEVAC_Show: {
                get() {
                    return this.pinfo != null && this.pinfo.hasOwnProperty('sumEVAC') && this.pinfo.sumEVAC != null ? this.pinfo.sumEVAC.show : true;
                },
            },
            sum: {
                get() {
                    return this.pinfo != null && this.pinfo.hasOwnProperty('sum') && this.pinfo.sum != null ? this.pinfo.sum.np : '';
                },
            },
            sum_OnD: {
                get() {
                    return this.pinfo != null && this.pinfo.hasOwnProperty('sum') && this.pinfo.sum != null ? this.pinfo.sum.onD : true;
                },
            },
            sum_Show: {
                get() {
                    return this.pinfo != null && this.pinfo.hasOwnProperty('sum') && this.pinfo.sum != null ? this.pinfo.sum.show : true;
                },
            },


        },
        methods: {
            getGpValue(gp, np, disc) {
                const hasDisc = disc != null && disc !== '';
                const isDifferent = gp !== np;

                return isDifferent && !hasDisc ? '' : gp;
            },
            lockBackgroundScroll() {
                document.body.style.overflowY = 'hidden';
            },
            unlockBackgroundScroll() {
                document.body.style.overflowY = '';
            },
            printOffer() {
                const originalTitle = document.title;
                const originalUrl = window.location.href;
                const printBaseUrl = `${window.location.protocol}//${window.location.host}/`;
                const zlwValue = this.zlw != null && String(this.zlw).trim() !== '' ? String(this.zlw).trim() : 'zlw';
                var suggestedFileName = `Order Inquiry  ${zlwValue}.pdf`;
                if (zlwValue == 'zlw') {
                    const now = new Date();
                    const date = now.toLocaleDateString('de-DE');
                    const time = now.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
                    const stringDateTime = `ZAlift ${date} ${time}`;
                    suggestedFileName = `Order Inquiry  ${stringDateTime}.pdf`;
                }

                const restoreTitle = () => {
                    document.body.classList.remove('offer-print-active');
                    document.title = originalTitle;
                    try {
                        window.history.replaceState(window.history.state, '', originalUrl);
                    }
                    catch (e) {
                    }
                    window.removeEventListener('afterprint', restoreTitle);
                };

                document.body.classList.add('offer-print-active');
                document.title = suggestedFileName;
                try {
                    window.history.replaceState(window.history.state, '', printBaseUrl);
                }
                catch (e) {
                }
                window.addEventListener('afterprint', restoreTitle);
                window.print();
                setTimeout(restoreTitle, 1500);
            },
            async closeModal() {
                document.body.classList.remove('offer-print-active');
                this.unlockBackgroundScroll();
                this.$emit('close');
            },

            isDataANumber(value) {

                if (value == null || value == "") {
                    return "";
                }

                else {
                    return String(this.ValueDecimalSeparator(value.toFixed(2)));
                }
            },
            ValueDecimalSeparator(value) {
                if (value != null) {
                    const localDecimal = { value: value, country: this.$store.state.configurations.language, }
                    return this.$get_decimalValueToLocaleString(localDecimal);
                }
                return value;
            },

        },
        mounted() {
            this.lockBackgroundScroll();
        },
        beforeDestroy() {
            document.body.classList.remove('offer-print-active');
            this.unlockBackgroundScroll();
        },
    }
</script>

<style>
    .offer_modal-dialog {
        max-width: none !important;
        width: 100vw !important;
    }
    /* === Overlay (Mask) === */
    .offer_modal-mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.5); /* halbtransparent */
        z-index: 9999;
        display: flex;
        align-items: center; /* vertikal zentriert */
        justify-content: center; /* horizontal zentriert */
    }

    /* === Container (eigentliches Modal) === */
    .offer_modal-container {
        background-color: #ffffff;
        border-radius: 8px;
        box-shadow: 0 10px 30px rgba(0,0,0,0.25);
        width: calc(100vh - 40px) !important;
        max-width: calc(100vh - 40px) !important;
        /*        max-width: 1000px !important;*/
        min-width: 600px;
        height: calc(100vh - 40px);
        max-height: calc(100vh - 40px);
        margin-bottom: 50px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    /* === Header === */
    .offer_modal-header {
        padding: 16px 20px;
        border-bottom: 1px solid #eee;
        font-size: 18px;
        font-weight: 600;
    }

    .offer_modal-content-a4 {
        width: min(100%, 210mm);
        margin-left: auto;
        margin-right: auto;
    }

    /* === Body === */
    .offer_modal-body {
        padding: 20px;
        flex: 1; /* wächst */
        overflow-y: auto;
        overscroll-behavior: contain;
        scrollbar-gutter: stable;
    }

    /* === Footer === */
    .offer_modal-footer {
        padding: 16px 20px;
        border-top: 1px solid #eee;
    }

    .offer_modal-footer-content {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
    }

    .offer_modal-print-footer {
        display: none;
    }

    .offer_link {
        color: inherit;
        text-decoration: underline;
    }



    .paddingColumn {
        padding: 2px 4px;
    }

    .blue {
        color: #0a1f8f;
    }

    .smallSize {
        font-size: 14px;
    }

    .section-title {
        background: #0a1f8f;
        color: white;
        margin-top: 20px;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 50px;
        font-size: 16px;
    }

    td {
        padding: 5px;
        vertical-align: top;
    }

    .compact-motor-row td {
        padding-top: 1px;
        padding-bottom: 1px;
    }

    .left {
        text-align: left;
    }

    .right {
        text-align: right;
    }

    .abstand-zeile {
        height: 15px;
    }

        .abstand-zeile td {
            border: none;
        }

    .sum {
        font-weight: bold;
        border-top: 2px solid black;
    }

    .td-grid {
        display: grid;
        grid-template-columns: 250px 1fr;
        align-items: center;
    }

    .headline_size {
        font-size: 18px !important;
    }

    @media print {

        .ZAbrand {
            max-height: 20mm;
            height: auto;
        }


        @page {
            size: A4;
            margin-top: 10mm;
            margin-right: 12mm;
            margin-bottom: 10mm;
            margin-left: 12mm;
        }


        html,
        body {
            margin: 0 !important;
            padding: 0 !important;
            overflow: visible !important;
            height: auto !important;
        }

            body.offer-print-active * {
                visibility: hidden;
            }

            body.offer-print-active .offer_modal-mask,
            body.offer-print-active .offer_modal-mask * {
                visibility: visible;
            }

        .offer_modal-mask {
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            width: 100% !important;
            height: auto !important;
            background: white !important;
            display: block !important;
            overflow: visible !important;
        }

        .offer_modal-wrapper,
        .offer_modal-container,
        .offer_modal-body {
            display: block !important;
            width: 100% !important;
            max-width: none !important;
            min-width: 0 !important;
            height: auto !important;
            max-height: none !important;
            overflow: visible !important;
            box-shadow: none !important;
            border-radius: 0 !important;
        }

        .offer_modal-body {
            padding-bottom: 16mm !important;
        }

        .offer_modal-header {
            padding-bottom: 5mm !important;
            border-bottom: none !important;
        }

        .offer_modal-footer {
            display: none !important;
        }


        .offer_modal-print-footer {
            display: block !important;
            position: fixed;
            left: 12mm;
            right: 12mm;
            bottom: 0;
            margin-top: 0;
            padding-top: 2mm;
            border-top: 1px solid #000;
            text-align: center !important;
            font-size: 9pt !important;
            color: #555;
            page-break-inside: avoid;
            break-inside: avoid;
        }


        .offer_modal-content-a4 {
            width: 100% !important;
            max-width: none !important;
        }


        table {
            page-break-inside: avoid !important;
            break-inside: avoid !important;
            margin-top: 0 !important;
            margin-bottom: 8mm !important;
        }

            table::before {
                content: "";
                display: block;
                height: 10mm;
            }


            table:first-child {
                margin-top: 0 !important;
            }

        tr {
            page-break-inside: avoid;
        }

        td,
        th {
            font-size: 10pt !important;
            vertical-align: top;
            white-space: normal !important;
            word-break: break-word !important;
            overflow-wrap: break-word !important;
        }

        .td-grid {
            display: table !important;
            width: 100%;
        }

            .td-grid > span:first-child {
                display: table-cell;
                width: 60mm;
                padding-right: 3mm;
            }

            .td-grid > span:last-child {
                display: table-cell;
            }


        .section-title {
            background: #00338e !important;
            color: white !important;
            display: table-row;
            page-break-after: avoid;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
        }
        /*            .section-title th {
                padding-top: 8mm !important;
                padding-bottom: 2mm !important;
            }*/

        .abstand-zeile {
            height: 3mm !important;
        }

        .smallSize,
        .ZAfont_size {
            font-size: 12pt !important;
        }

        .headline_size {
            font-size: 14pt !important;
        }

        img {
            max-width: 100% !important;
            height: auto !important;
        }
    }
</style>
